import { clearPhoneNumber } from '@gem/utils';

import { ValidationErrorType } from './fields';

interface IPhoneNumberValidateParams {
  value: string;
  errorToText: Partial<Record<ValidationErrorType, string>>;
  data: {
    phoneTemplate?: string;
  };
}

export const phoneNumberValidation = ({
  value = '',
  errorToText,
  data: { phoneTemplate },
}: IPhoneNumberValidateParams): string | null => {
  const phone = '+' + clearPhoneNumber(value);
  if (
    phone === '+' ||
    (phoneTemplate && phone.length - 1 < phoneTemplate.replace(/[^X]/g, '').length - 1)
  ) {
    return errorToText[ValidationErrorType.PhoneInvalid] || '';
  }
  return null;
};

// Needs Bff implementation
export const phoneNumberAsyncValidation = async (): Promise<null> => {
  return null;
};
